/**
 * useRightFront - which panel THIS viewer's right column shows: the story's,
 * Stealth's or the target's.
 *
 * The phase says which is in front (`engine/phase/layout`); the viewer may
 * reach for the other, and that choice lasts until the phase changes - the
 * same shape as the map's fold (`useMapFold`). Nothing is locked: both
 * panels stay mounted, and the other is one press away.
 *
 * @param {import('../engine/phase/types').Phase | null} phase - the phase on this screen
 * @returns {{ front: 'story' | 'stealth' | 'target', show: (which: 'story' | 'stealth' | 'target') => void }}
 */
import { useCallback, useState } from 'react';
import { layoutOf } from '../engine/phase/layout';

export default function useRightFront(phase) {
  // The viewer's own choice, and the phase it was made in. In any other phase the layout's word stands.
  const [chosen, setChosen] = useState(null);
  // Forgotten as soon as the phase moves on (state adjusted while rendering, no effect), so coming
  // back to a phase does not bring an old choice back with it.
  if (chosen && chosen.phase !== phase) setChosen(null);
  const front = chosen?.phase === phase ? chosen.front : layoutOf(phase).rightFront;
  const show = useCallback((which) => setChosen({ phase, front: which }), [phase]);
  return { front, show };
}
